import { render, staticRenderFns } from "./LongTextBubble.vue?vue&type=template&id=440b26d2&scoped=true&"
import script from "./LongTextBubble.vue?vue&type=script&lang=js&"
export * from "./LongTextBubble.vue?vue&type=script&lang=js&"
import style0 from "./LongTextBubble.vue?vue&type=style&index=0&id=440b26d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b26d2",
  null
  
)

export default component.exports